module.exports = __webpack_public_path__ + "img/cta_default.2e046b05.png";